export default __webpack_public_path__ + "static/media/flw_blue.d18e7d61.jpg";